<template>
  <div class="home" v-if="proposal">
    <a-header 
      :company="employer.Name"
      title="Help protect yourself and your family."
      body="Learn more about your voluntary benefit options from Assurity."
      :image="require('@/assets/images/home-banner.png')"
    >
    </a-header>
    <div class="arrow-img__container"><img src="/images/Arrow-1.svg" alt="" class="arrow-img" /></div>
    <div class="section-header">
      <div class="section-header__main">Your Benefit Options</div>
      <a-dotted-line />
    </div>
    <div class="section" v-for="product in products" :key="product.Id">
      <component :is="product.Id" />
    </div>
  </div>
</template>

<script>
import AHeader from '@/components/a-header'
import ADottedLine from '@/components/a-dotted-line'
import {
  AccidentExpense,
  CriticalIllness,
  HospitalIndemnity,
  ShortTermDisability as DisabilityIncome,
  WholeLife,
} from '@/components/product-overviews'
import { mapGetters } from 'vuex'
export default {
  name: 'Home',
  components: {
    AHeader,
    AccidentExpense,
    CriticalIllness,
    HospitalIndemnity,
    DisabilityIncome,
    WholeLife,
    ADottedLine,
  },
  computed: {
    ...mapGetters({
      employer: 'getEmployer',
      products: 'getProducts',
      proposal: 'getProposal'
    })
  }
}
</script>
<style lang="scss" scoped>
.arrow-img {
  position: absolute;
  width: 170px;
  height: auto;
  left: 50%;
  bottom: 5px;
  transform: translate(-50%, 0);
  margin-left: 200px;
  z-index: 1;
  @media(max-width: 1200px) {
    margin-left: 60px;
  }
  @media(max-width: 800px) {
    width: 20%;
    left: 10%;
    transform: translate(0, 0);
  }
  &__container {
    position: relative;
  }
}
.section-header {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 70px;
  padding: 0 30px;
}
.section-header__sub {
  font-size: 1.2em;
  font-style: italic;
  color: $gray;
}
.section-header__main {
  font-size: 2.5em;
  font-weight: bold;
  color: $red;
}
.section {
  max-width: 1700px;
  margin: 50px auto;
  padding: 0 $spacing-md;
  @include tablet-landscape {
    padding: 0 $spacing-xl;
  }
}
</style>
